import DashboardLayout from "./DashboardShell";
import { DASH } from "@/constants/testIds";
import {
  LayoutDashboard, BookOpen, ClipboardCheck, GraduationCap,
  Award, MessageSquare, User, DollarSign, NotebookPen, TrendingUp, FileText, Bell, Megaphone,
} from "lucide-react";
import { NotificationsInboxTab, AnnouncementsFeedTab } from "./manager/comms";
import { MessagesTab } from "./shared/messages";
import {
  StudentOverviewTab, StudentCourseTab, StudentAttendanceTab,
  StudentExamsTab, StudentProfileTab,
} from "./student/tabs";
import { StudentFeesTab, StudentCertificatesTab } from "./student/finance";
import {
  StudentHomeworkTab, StudentExamResultsTab, StudentProgressSummaryTab,
  StudentProgressReportsTab, StudentLessonTab,
} from "./student/progress";

export default function StudentDashboard() {
  const tabs = [
    { key: "overview", label: "Overview", icon: LayoutDashboard, render: () => <StudentOverviewTab /> },
    { key: "lesson", label: "Today's Lesson", icon: NotebookPen, render: () => <StudentLessonTab /> },
    { key: "course", label: "My Course", icon: BookOpen, render: () => <StudentCourseTab /> },
    { key: "attendance", label: "Attendance", icon: ClipboardCheck, render: () => <StudentAttendanceTab /> },
    { key: "homework", label: "Homework", icon: GraduationCap, render: () => <StudentHomeworkTab /> },
    { key: "exams", label: "Exam Time", icon: Award, render: () => <StudentExamsTab /> },
    { key: "results", label: "Exam Results", icon: FileText, render: () => <StudentExamResultsTab /> },
    { key: "progress", label: "Progress", icon: TrendingUp, render: () => <StudentProgressSummaryTab /> },
    { key: "reports", label: "Progress Reports", icon: FileText, render: () => <StudentProgressReportsTab /> },
    { key: "fees", label: "Fees", icon: DollarSign, render: () => <StudentFeesTab /> },
    { key: "certificates", label: "Certificates", icon: Award, render: () => <StudentCertificatesTab /> },
    { key: "notifications", label: "Notifications", icon: Bell, render: () => <NotificationsInboxTab /> },
    { key: "announcements", label: "Announcements", icon: Megaphone, render: () => <AnnouncementsFeedTab /> },
    { key: "messages", label: "Messages", icon: MessageSquare, render: () => <MessagesTab role="student" /> },
    { key: "profile", label: "Profile", icon: User, render: () => <StudentProfileTab /> },
  ];
  return <DashboardLayout role="Student" testid={DASH.studentRoot} tabs={tabs} />;
}
